/* eslint-disable no-param-reassign */
import React from 'react';
import { Mutation } from '@apollo/client/react/components';
import DeleteIcon from '@material-ui/icons/Delete';
import { IconButton } from '@material-ui/core';
import { DELETE_USER, GET_CM_AND_EDITORS } from '../../../queries/user';

function filteredData(s, l, ls) {
  s.data.forEach(d => {
    const { id } = ls[d.dataIndex];
    l = l.filter(e => e.id !== id);
  });
  return l;
}

// eslint-disable-next-line react/prefer-stateless-function
class Delete extends React.Component {
  render() {
    const { selectedRows, users } = this.props;
    return (
      <Mutation
        mutation={DELETE_USER}
        update={(store) => {
          const { users } = store.readQuery({ query: GET_CM_AND_EDITORS });
          store.writeQuery({
            query: GET_CM_AND_EDITORS,
            data: { users: filteredData(selectedRows, users, users) },
          });
        }}
      >
        {deleteUser => (
          <div>
            <IconButton
              aria-label="delete"
              onClick={
              e => {
                e.preventDefault();
                selectedRows.data.forEach(d => {
                  const { id } = users[d.dataIndex];
                  deleteUser({ variables: { id } });
                });
              }
            }
            >
              <DeleteIcon />
            </IconButton>
          </div>
        )}
      </Mutation>
    );
  }
}

export default Delete;
